export const NOT_YET_STATUS_TASK_CHECK = 'NOT_YET';

export enum StatusTaskCheckEnum {
    CREATED = 'Created',
    DONE = 'Done',
    CANCEL = 'Cancelled',
    DRAFT = 'Draft',
    NOT_YET = 'Not_Yet',
    DECLINED = 'Declined',
}
